var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 501,
    viewBox: "0 0 338 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.795 115.198L381.572 29.6749V-13.5967L296.795 71.3478V115.198Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M255.062 73.4152L296.799 115.199V71.3495L255.062 28.6648V73.4152Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M296.876 31.951L339.836 -11.788V-55L296.795 -12.2813L296.876 31.951Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.009 243.684L296.786 158.16V114.889L212.009 199.833V243.684Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M170.276 201.9L212.013 243.684V199.834L170.276 157.149V201.9Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M212.09 160.435L255.05 116.696V73.4844L212.009 116.203L212.09 160.435Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M296.8 201.898L338.536 243.682V199.832L296.8 157.148V201.898Z",
    fill: "#4569FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.506 372.512L211.283 286.989V243.717L126.506 328.662V372.512Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M84.7734 330.728L126.51 372.513V328.663L84.7734 285.978V330.728Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M126.587 289.265L169.547 245.526V202.314L126.506 245.033L126.587 289.265Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7324 500.999L126.509 415.476V372.204L41.7324 457.149V500.999Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 459.215L41.7367 500.999V457.149L0 414.465V459.215Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M41.8139 417.75L84.7734 374.011V330.799L41.7324 373.518L41.8139 417.75Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.014 372.511L337.79 286.988V243.717L253.014 328.661V372.511Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M211.281 330.728L253.018 372.512V328.662L211.281 285.977V330.728Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M253.095 289.264L296.055 245.525V202.313L253.014 245.032L253.095 289.264Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.252 500.994L253.029 415.471V372.199L168.252 457.144V500.994Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M126.52 459.21L168.256 500.994V457.144L126.52 414.46V459.21Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M168.333 417.745L211.293 374.006V330.794L168.252 373.513L168.333 417.745Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.76 500.999L379.536 415.476V372.204L294.76 457.149V500.999Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M253.027 459.215L294.764 500.999V457.149L253.027 414.465V459.215Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M294.841 417.75L337.801 374.011V330.799L294.76 373.518L294.841 417.75Z",
    fill: "#4569FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackgroundMobile);
export default __webpack_public_path__ + "static/media/Auth_background_mobile.86963c86bfff6cacd92080ca4c4d439f.svg";
export { ForwardRef as ReactComponent };